import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import FilterTag from './FilterTag';
import { EATING_TAGS, DISH_TYPE_TAGS, CATEGORY_INGREDIENTS } from '../../../constants/appConstants';
import ArrowIcon from '../../../images/arrow.png';

const categoriesInfo = [
  {
    name: 'Тип приёма:',
    categoryId: EATING_TAGS,
  },
  {
    name: ' Вид блюда:',
    categoryId: DISH_TYPE_TAGS,
  },
  {
    name: 'Категории продуктов:',
    categoryId: CATEGORY_INGREDIENTS,
  },
];

const FilterByTags = ({ tags, onChooseTagForSearch, choosedFiltersIds = [] }) => {
  if (!tags || !tags.length) return null;
  const [isOpened, setIsOpened] = useState(false);
  const open = () => {
    setIsOpened(!isOpened);
  };
  return (
    <FilterWrapper>
      <FilterTitle onClick={open}>
        Фильтровать блюда
        <Img src={ArrowIcon} alt="arrow" isOpened={isOpened} />
      </FilterTitle>
      <Collapse isOpened={isOpened}>
        {categoriesInfo.map((category) => {
          const categoryTags = tags.filter((tag) => tag.category_id === category.categoryId);
          return (
            <React.Fragment key={category.name + category.id}>
              <CategoryFiltersTitle>{category.name}</CategoryFiltersTitle>
              <FilterBoxes>
                {!!categoryTags.length &&
                  categoryTags.map((tag) => (
                    <FilterTag
                      key={tag.tag_id + tag.name}
                      isChecked={choosedFiltersIds.includes(tag.tag_id)}
                      name={tag.name}
                      tagId={tag.tag_id}
                      onChoose={onChooseTagForSearch}
                    />
                  ))}
                <EmptyBlock />
                <EmptyBlock />
                <EmptyBlock />
                <EmptyBlock />
              </FilterBoxes>
            </React.Fragment>
          );
        })}
      </Collapse>
    </FilterWrapper>
  );
};

export default FilterByTags;

const FilterWrapper = styled.div`
  width: 95%;
  box-sizing: border-box;
  margin: 0 auto;
`;
const FilterBoxes = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  position: relative;
  padding: 5px 20px;
  width: 100%;
  box-sizing: border-box;
  font-size: 24px;
`;

const FilterTitle = styled.h3`
  margin: 10px 0;
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 40px;
  cursor: pointer;
  background: #157aac;
  color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
`;

const Img = styled.img`
  margin-left: 25px;
  width: 15px;
  height: 15px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(180deg)' : '')};
`;

const CategoryFiltersTitle = styled.div`
  font-size: 19px;
  font-weight: bold;
  text-align: left;
  padding: 5px 20px;
`;

const EmptyBlock = styled.div`
  width: 20%;
  min-width: 200px;
  height: 0px;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/FilterBar/FilterByTags.jsx